// Mock data for Anto Arquitectura website - Bilingual content

export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      about: 'Acerca de',
      services: 'Servicios',
      contact: 'Contacto',
    },
    home: {
      hero: {
        title: 'ANTO ARQUITECTURA',
        subtitle: 'Diseño arquitectónico e interiorismo con visión contemporánea',
        cta: 'Ver Proyectos',
      },
      projects: {
        title: 'Proyectos Destacados',
        subtitle: 'Conoce nuestro trabajo',
        viewAll: 'Ver Todos los Proyectos',
      },
      values: {
        title: 'Nuestra Filosofía',
        items: [
          {
            title: 'Diseño Innovador',
            description: 'Creamos espacios únicos que reflejan tu visión',
          },
          {
            title: 'Calidad Superior',
            description: 'Excelencia en cada detalle de nuestros proyectos',
          },
          {
            title: 'Experiencia',
            description: 'Años de trayectoria en arquitectura e interiorismo',
          },
        ],
      },
    },
    about: {
      title: 'Acerca de Nosotros',
      subtitle: '¿Quiénes somos?',
      description: 'ANTO Arquitectura es un estudio especializado en arquitectura e interiorismo que combina creatividad, funcionalidad y estética contemporánea. Nuestro enfoque se centra en crear espacios que no solo cumplan con las necesidades de nuestros clientes, sino que también los inspiren.',
      mission: {
        title: 'Nuestra Misión',
        description: 'Transformar ideas en espacios excepcionales a través del diseño arquitectónico innovador y el interiorismo de vanguardia.',
      },
      vision: {
        title: 'Nuestra Visión',
        description: 'Ser reconocidos como líderes en diseño arquitectónico contemporáneo, creando espacios que mejoren la calidad de vida de las personas.',
      },
      team: {
        title: 'Nuestro Equipo',
        description: 'Un equipo multidisciplinario de arquitectos, diseñadores e ingenieros comprometidos con la excelencia.',
      },
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Soluciones integrales en arquitectura e interiorismo',
      list: [
        {
          title: 'Diseño Arquitectónico',
          description: 'Proyectos arquitectónicos completos desde la conceptualización hasta la construcción. Diseñamos espacios funcionales y estéticamente únicos.',
          features: ['Diseño conceptual', 'Planos ejecutivos', 'Supervisión de obra', 'Render 3D'],
        },
        {
          title: 'Interiorismo',
          description: 'Diseño de interiores que transforma espacios en ambientes acogedores y funcionales, reflejando tu personalidad y estilo.',
          features: ['Diseño de espacios', 'Selección de materiales', 'Mobiliario personalizado', 'Iluminación'],
        },
        {
          title: 'Remodelación',
          description: 'Renovamos y transformamos espacios existentes para adaptarlos a nuevas necesidades y estilos de vida contemporáneos.',
          features: ['Remodelación residencial', 'Remodelación comercial', 'Ampliaciones', 'Renovación integral'],
        },
        {
          title: 'Consultoría',
          description: 'Asesoría profesional en proyectos arquitectónicos y de diseño para optimizar recursos y garantizar resultados excepcionales.',
          features: ['Asesoría técnica', 'Gestión de proyectos', 'Viabilidad', 'Optimización de espacios'],
        },
      ],
    },
    contact: {
      title: 'Contacto',
      subtitle: 'Queremos ayudarte, ¡contáctanos!',
      info: {
        phone: 'Teléfono',
        email: 'Correo Electrónico',
        address: 'Dirección',
        hours: 'Horario de Atención',
      },
      social: 'Síguenos en Redes Sociales',
      cta: 'Comencemos tu Proyecto',
    },
    footer: {
      tagline: 'Arquitectura e Interiorismo Contemporáneo',
      rights: 'Todos los derechos reservados.',
      links: 'Enlaces Rápidos',
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact',
    },
    home: {
      hero: {
        title: 'ANTO ARCHITECTURE',
        subtitle: 'Contemporary architectural design and interior design',
        cta: 'View Projects',
      },
      projects: {
        title: 'Featured Projects',
        subtitle: 'Explore our work',
        viewAll: 'View All Projects',
      },
      values: {
        title: 'Our Philosophy',
        items: [
          {
            title: 'Innovative Design',
            description: 'We create unique spaces that reflect your vision',
          },
          {
            title: 'Superior Quality',
            description: 'Excellence in every detail of our projects',
          },
          {
            title: 'Experience',
            description: 'Years of expertise in architecture and interior design',
          },
        ],
      },
    },
    about: {
      title: 'About Us',
      subtitle: 'Who we are?',
      description: 'ANTO Architecture is a studio specialized in architecture and interior design that combines creativity, functionality and contemporary aesthetics. Our approach focuses on creating spaces that not only meet our clients\' needs, but also inspire them.',
      mission: {
        title: 'Our Mission',
        description: 'Transform ideas into exceptional spaces through innovative architectural design and cutting-edge interior design.',
      },
      vision: {
        title: 'Our Vision',
        description: 'To be recognized as leaders in contemporary architectural design, creating spaces that improve people\'s quality of life.',
      },
      team: {
        title: 'Our Team',
        description: 'A multidisciplinary team of architects, designers and engineers committed to excellence.',
      },
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive solutions in architecture and interior design',
      list: [
        {
          title: 'Architectural Design',
          description: 'Complete architectural projects from conceptualization to construction. We design functional and aesthetically unique spaces.',
          features: ['Conceptual design', 'Executive plans', 'Construction supervision', '3D Rendering'],
        },
        {
          title: 'Interior Design',
          description: 'Interior design that transforms spaces into welcoming and functional environments, reflecting your personality and style.',
          features: ['Space design', 'Material selection', 'Custom furniture', 'Lighting'],
        },
        {
          title: 'Remodeling',
          description: 'We renovate and transform existing spaces to adapt them to new needs and contemporary lifestyles.',
          features: ['Residential remodeling', 'Commercial remodeling', 'Expansions', 'Complete renovation'],
        },
        {
          title: 'Consulting',
          description: 'Professional advice on architectural and design projects to optimize resources and guarantee exceptional results.',
          features: ['Technical advice', 'Project management', 'Feasibility', 'Space optimization'],
        },
      ],
    },
    contact: {
      title: 'Contact',
      subtitle: 'We want to help you, contact us!',
      info: {
        phone: 'Phone',
        email: 'Email',
        address: 'Address',
        hours: 'Business Hours',
      },
      social: 'Follow Us on Social Media',
      cta: 'Let\'s Start Your Project',
    },
    footer: {
      tagline: 'Contemporary Architecture and Interior Design',
      rights: 'All rights reserved.',
      links: 'Quick Links',
    },
  },
};

export const contactInfo = {
  phone: '+52 (55) 1234-5678',
  email: 'contacto@antoarquitectura.com',
  address: 'Ciudad de México, México',
  hours: 'Lun - Vie: 9:00 AM - 6:00 PM',
  social: {
    facebook: 'https://www.facebook.com/marcoantonioperezrojass/',
    instagram: 'https://www.instagram.com/anto_arquitectura/',
  },
};

export const projects = [
  {
    id: 1,
    title: 'Casa Moderna Valle',
    category: 'Residencial',
    image: 'https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3MDQwMzc2Nnww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 2,
    title: 'Torre Corporativa',
    category: 'Comercial',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzcwNDAzNzgwfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 3,
    title: 'Residencia Contemporánea',
    category: 'Residencial',
    image: 'https://images.unsplash.com/photo-1651093791352-2ae1c9e5e428?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxyZXNpZGVudGlhbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzA0MDM3NzF8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 4,
    title: 'Edificio de Oficinas',
    category: 'Comercial',
    image: 'https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzcwNDAzNzgwfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 5,
    title: 'Diseño de Interiores Premium',
    category: 'Interiorismo',
    image: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzcwNDAzNzgwfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 6,
    title: 'Espacio Corporativo',
    category: 'Interiorismo',
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzcwNDAzNzgwfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 7,
    title: 'Casa Minimalista',
    category: 'Residencial',
    image: 'https://images.unsplash.com/photo-1610526662524-bd113e746fdb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxyZXNpZGVudGlhbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzA0MDM3NzF8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 8,
    title: 'Edificio Moderno',
    category: 'Comercial',
    image: 'https://images.unsplash.com/photo-1633807422423-05410d114d61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3MDQwMzc2Nnww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 9,
    title: 'Proyecto Arquitectónico',
    category: 'Residencial',
    image: 'https://images.pexels.com/photos/33251467/pexels-photo-33251467.jpeg',
  },
];
